var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpenseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_4935",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H42V42H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_4935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7497 21H9.47424C9.12817 20.9999 8.7899 20.8972 8.50218 20.7049C8.21447 20.5126 7.99022 20.2393 7.8578 19.9196C7.72538 19.5999 7.69072 19.2481 7.75822 18.9087C7.82571 18.5693 7.99232 18.2575 8.23699 18.0127L19.7625 6.48723C20.0907 6.15916 20.5357 5.97485 20.9997 5.97485C21.4638 5.97485 21.9088 6.15916 22.237 6.48723L33.7625 18.0127C34.0072 18.2575 34.1738 18.5693 34.2413 18.9087C34.3088 19.2481 34.2741 19.5999 34.1417 19.9196C34.0093 20.2393 33.785 20.5126 33.4973 20.7049C33.2096 20.8972 32.8713 20.9999 32.5252 21H26.2497V26.25H15.7497V21Z",
    stroke: "#FB4945",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 36.75H26.25",
    stroke: "#FB4945",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 31.5H26.25",
    stroke: "#FB4945",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenseIcon);
export default __webpack_public_path__ + "static/media/expense-icon.5c768a297f9b272b8e73c03bf2176eb6.svg";
export { ForwardRef as ReactComponent };